'use strict';

import ApiEndpoint from './api_endpoint';

export default class DestroyChild extends ApiEndpoint {
  execute(callback = undefined, session = undefined, externalIdentifier = '') {
    if (session === undefined) {
      return this.session.delete('/people/' + externalIdentifier + '/destroy_child', undefined, callback);
    }
    return session.delete('/people/' + externalIdentifier + '/destroy_child', undefined, callback);
  }
}
